import { globals } from '../../globals'
import { logOut } from './auth'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_ALL_BILL_TYPES = 'GET_ALL_BILL_TYPES'
export const ALL_BILL_TYPES_FETCHED = 'ALL_BILL_TYPES_FETCHED'
export const GET_ALL_BILL_TYPES_FAILED = 'GET_ALL_BILL_TYPES_FAILED'
export const FILTER_BILL_TYPES = 'FILTER_BILL_TYPES'
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function getAllBillTypes (stateValue) {
  return (dispatch) => {
    dispatch({ type: GET_ALL_BILL_TYPES })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/billtype/all`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: ALL_BILL_TYPES_FETCHED,
          payload: {
            json,
            stateValue
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_ALL_BILL_TYPES_FAILED })
    })
  }
}

export function filterBillTypesByStates (stateValue) {
  return {
    type: FILTER_BILL_TYPES,
    stateValue
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ALL_BILL_TYPES_FETCHED] : (state, action) => {
    const { json } = action.payload
    let types = []
    let resultedTypes = []
    json.map(item => {
      if (!types.includes(`${item.TypeCode} - ${item.Description}`)) {
        types = [...types, `${item.TypeCode} - ${item.Description}`]
        resultedTypes = [
          ...resultedTypes, {
            label: `${item.TypeCode} - ${item.Description}`,
            value: item.TypeCode
          }
        ]
      }
    })
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allBillTypes: json,
        billTypes: resultedTypes
      }
    }
  },
  [FILTER_BILL_TYPES] : (state, action) => {
    let findBillTypes = []
    if (action.stateValue) {
      findBillTypes = state.renderData.allBillTypes.filter(el => el.RegionCode === action.stateValue).map(item => {
        return {
          label: `${item.TypeCode} - ${item.Description}`,
          value: item.TypeCode
        }
      })
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        billTypes: findBillTypes
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {}
}
export default function billTypesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/billTypes.js